import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'
import { NavItem } from "containers/SingIn/types";
import images from "../../assets/images";
import NavigationMenuItem from "./NavigationMenuItem";

interface SidebarProps {
    navigation: NavItem[];
    sidebarOpen: boolean;
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setDialogOpen: (open: boolean) => void;
}

// Sidebar Component
const Sidebar: React.FC<SidebarProps> = ({ navigation, sidebarOpen, setSidebarOpen, setDialogOpen }) => (
    <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 flex z-40 md:hidden" onClose={setSidebarOpen}>
            <Transition.Child
                as={Fragment}
                enter="transition-opacity ease-linear duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity ease-linear duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
            </Transition.Child>
            <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
            >
                <div className="relative flex-1 flex flex-col max-w-xs w-full pb-4 bg-primary">
                    <div className="absolute top-0 right-0 p-1">
                        <button
                            type="button"
                            className="cursor-pointer ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none"
                            onClick={() => setSidebarOpen(false)}
                        >
                            <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                        </button>
                    </div>
                    <div className="flex items-center justify-center flex-shrink-0 px-4 py-4">
                        <img
                            className="h-24 w-auto"
                            style={{ width: "176px", height: "45px" }}
                            src={images.logoTMW}
                            alt="Workflow"
                        />
                    </div>
                    <nav className="flex-1 px-2 pb-4 space-y-1">
                        {navigation.map((item) => (
                            <NavigationMenuItem key={item.name} item={item} setDialogOpen={setDialogOpen} />
                        ))}
                    </nav>
                </div>
            </Transition.Child>
            <div className="flex-shrink-0 w-14" aria-hidden="true"></div>
        </Dialog>
    </Transition.Root>
);

export default Sidebar;